import LogoutCallback from './LogoutCallback.vue'

export default LogoutCallback